//Tipos
import {
  SET_MAIS_DETALHES_FIELD,
  LOADING_MAIS_DETALHES,
  ERROR_MAIS_DETALHES,
} from './types';

export const setMaisDetalhesFieldAction = data => ({
  type: SET_MAIS_DETALHES_FIELD,
  payload: data
})

export const loadingMaisDetalhesAction = bool => ({
  type: LOADING_MAIS_DETALHES,
  payload: bool
})

export const setErrorMaisDetalhesAction = message => ({
  type: ERROR_MAIS_DETALHES,
  payload: message
})